import script from "./ChangeBookingLimits.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeBookingLimits.vue?vue&type=script&setup=true&lang=js"

import "./ChangeBookingLimits.vue?vue&type=style&index=0&id=594e75d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594e75d8"]])

export default __exports__